import { API_URLS } from "../../../Configs/apiUrls";
import axiosInstance from "../../../Configs/axios";

export const productsFn = (redBody) => {
  try {
    const response = axiosInstance.post(API_URLS.productList, redBody);
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};
